import { initProductCardSlider } from '../woocommerce/content-product.js';

jQuery(function($) {

    if ($('.producten').length == 0) {
        return;
    }

    $('.producten').each(function () {
        const $block = $(this);

        const postsContainer = $block.find('.producten__container');
        const paginationContainer = $block.find('.pagination-container');
        const productCount = $block.find('.producten__count');
        const productCountFull = $block.find('.producten__count--full');

        let activeCategories = $block.data('categorie');
        let pageNumber = 1;
        let sorting = '';
        let filters = {};
        let soortProducten = 'beide';

        activeCategories = activeCategories ? activeCategories.split(',') : [];

        updateFilterCounts();

        function fetchPosts(categories = [], pageNumber = 1, ordering = 'date', filters = {}, soortProducten = 'beide') {
            $.ajax({
                url: wemake.ajax_url,
                type: 'POST',
                data: {
                    action: 'get_modellen_by_filter',
                    categories: categories,
                    paged: pageNumber,
                    ordering: ordering,
                    filters: filters,
                    soort_producten : soortProducten,
                },
                beforeSend: function () {
                    postsContainer.html('<div class="spinner-loader"></div>');
                    productCount.text('');
                },
                success: function (response) {
                    const data = JSON.parse(response);
                    postsContainer.html(data.modellen);
                    paginationContainer.html(data.pagination);
                    productCount.text('(' + data.total + ')');
                    productCountFull.text( data.total + ' ' + (data.total === 1 ? 'product' : 'producten'));
                    

                    initProductCardSlider();
                },
                error: function (xhr, status, error) {
                    console.error('Error:', error);
                }
            });
        }

        $block.on('click', '.pagination-container a', function(e) {
            e.preventDefault();
            const activePage = parseInt($block.find('.pagination-container .current').text());

            if ($(this).hasClass('prev')) {
                pageNumber = activePage - 1;
            } else if ($(this).hasClass('next')) {
                pageNumber = activePage + 1;
            } else {
                pageNumber = parseInt($(this).text()) || 1;
            }

            fetchPosts(activeCategories, pageNumber, sorting, filters, soortProducten);

            $('html, body').animate({
                scrollTop: $block.offset().top - (window.innerWidth > 767 ? 140 : -400)
            }, 20);
        });

        $block.on('click', '.producten__sort-option', function () {
            const $this = $(this);
            sorting = $this.data('value');
            $block.find('.producten__sort-selected').text($this.data('name'));
            $block.find('.producten__sort-option').removeClass('active');
            $this.addClass('active');


            fetchPosts(activeCategories, pageNumber, sorting, filters, soortProducten);
        });

        $block.on('change', '.producten__filter-option input[type="checkbox"]', function () {
            const $checkbox = $(this);
            const taxonomy = $checkbox.attr('name').replace('[]', '');
            const value = $checkbox.val();
            const isChecked = $checkbox.is(':checked');

            $block.find(`input[name="${$checkbox.attr('name')}"][value="${value}"]`).each(function () {
                if (this !== $checkbox[0]) {
                    $(this).prop('checked', isChecked);
                }
            });

            if (!filters[taxonomy]) {
                filters[taxonomy] = [];
            }

            if (isChecked) {
                if (!filters[taxonomy].includes(value)) {
                    filters[taxonomy].push(value);
                }
            } else {
                filters[taxonomy] = filters[taxonomy].filter(val => val !== value);

                if (filters[taxonomy].length === 0) {
                    delete filters[taxonomy];
                }
            }

            toggleRemoveFiltersButton();
            updateFilterCounts();
            fetchPosts(activeCategories, pageNumber, sorting, filters, soortProducten);
        });

        $block.on('click', '.producten__remove-filters', function () {
            filters = {};
            $block.find('.producten__filter-option input[type="checkbox"]').prop('checked', false);
            toggleRemoveFiltersButton();
            updateFilterCounts();
            fetchPosts(activeCategories, pageNumber, sorting, filters, soortProducten);
        });

        function toggleRemoveFiltersButton() {
            const hasFilters = Object.keys(filters).length > 0;
            $block.find('.producten__remove-filters').css('display', hasFilters ? 'flex' : 'none');
        }

        function updateFilterCounts() {
            const $filters = $block.find('.producten__filter-option input[type="checkbox"]');
            const selectedFilters = new Set();

            $block.find('.producten__filter').each(function () {
                const $filterGroup = $(this);
                const count = $filterGroup.find('input[type="checkbox"]:checked').length;

                $filterGroup.find('.producten__filter-count').text(count > 0 ? `(${count})` : '');
            });

            $filters.filter(':checked').each(function () {
                const name = $(this).attr('name');
                const value = $(this).val();
                selectedFilters.add(`${name}:${value}`);
            });

            $block.find('.producten__filter-total-count').text(selectedFilters.size > 0 ? `(${selectedFilters.size})` : '');
        }

        $block.on('click', '.producten__filter', function(e) {
            e.stopPropagation();

            let $this = $(this);
            let isActive = $this.hasClass('active');

            $block.find('.producten__filter').removeClass('active');

            if (!isActive) {
                $this.addClass('active');
            }
        });

        $block.on('click', '.producten__filter-options', function(e) {
            e.stopPropagation();
        });

        $(window).on('click', function () {
            $block.find('.producten__filter').removeClass('active');
        });


        $block.on('click', '.producten__switcher-soort-producten .switcher__option', function(e) {
            soortProducten = $(this).data('value');
            fetchPosts(activeCategories, pageNumber, sorting, filters, soortProducten);
        });

        $block.on('click', '#popup-filters .close-popup', function(){
            $('html, body').animate({
                scrollTop: $block.offset().top - 140
            }, 0);
        });
        
    }); // End .each loop


    
    /* Sticky control bar with filters */
    
    if ($(window).width() > 767) { 
        const $controls = $('.producten__controls');
        const $header = $('.site-header');
        const $producten = $('.producten');
        const adminBarHeight = $('#wpadminbar').length ? 32 : 0;

        if ($controls.length === 0 || $header.length === 0 || $producten.length === 0) return;

        const originalOffset = $controls.offset().top;

        // Create a spacer placeholder
        const $spacer = $('<div class="producten__controls-spacer" style="display: none;"></div>');
        $controls.before($spacer);

        $(window).on('scroll resize', function () {
            const scrollTop = $(window).scrollTop();
            const headerHeight = $header.outerHeight();
            const offsetTop = headerHeight + adminBarHeight;
            const controlsHeight = $controls.outerHeight();
            const productenBottom = $producten.offset().top + $producten.outerHeight();

            const controlsBottom = scrollTop + offsetTop + controlsHeight;

            // Reached the end of .producten?
            const pastEnd = controlsBottom >= productenBottom;

            if (scrollTop >= originalOffset - offsetTop && !pastEnd) {
                if (!$controls.hasClass('is-sticky')) {
                    $spacer.height(controlsHeight).show();

                    $controls.addClass('is-sticky').css({
                        position: 'fixed',
                        top: offsetTop,
                        width: '1200px',
                        zIndex: 50,
                        background: '#fff'
                    });
                }
            } else {
                if ($controls.hasClass('is-sticky')) {
                    $spacer.hide().height(0);
                    $controls.removeClass('is-sticky').removeAttr('style');
                }
            }
        });  
    }
});
